var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00272D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,0.4C11.4,0.4,0.4,11.4,0.4,25s11,24.6,24.6,24.6s24.6-11,24.6-24.6S38.6,0.4,25,0.4z M22.5,44.5 C12.8,43.3,5.3,35,5.3,25c0-1.5,0.2-3,0.5-4.4l11.8,11.8v2.5c0,2.7,2.2,4.9,4.9,4.9V44.5z M39.5,38.3c-0.6-2-2.5-3.4-4.7-3.4h-2.5 v-7.4c0-1.4-1.1-2.5-2.5-2.5H15.2v-4.9h4.9c1.4,0,2.5-1.1,2.5-2.5v-4.9h4.9c2.7,0,4.9-2.2,4.9-4.9v-1c7.2,2.9,12.3,10,12.3,18.2 C44.7,30.1,42.7,34.8,39.5,38.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.62a4e4d83c8a4212d4aca8d2de621bf6.svg";
export { ForwardRef as ReactComponent };